import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Makes routing tolerant of a trailing slash.
 *
 * Angular parses `/reports/<uuid>/` into segments ['reports', <uuid>, ''] - the
 * empty tail matches no child route, so the URL falls through to the '**'
 * wildcard and redirects to /manuscript-setup, silently dropping the query
 * string (and with it any `?accessToken=`). Report share links are generated
 * with that trailing slash, so the whole shape has to resolve.
 *
 * Only parse() is overridden; serialize() keeps producing canonical
 * slash-free URLs, so nothing downstream sees two spellings of a route.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const marker = url.search(/[?#]/);
    const path = marker === -1 ? url : url.slice(0, marker);
    const tail = marker === -1 ? '' : url.slice(marker);

    // Keep the root '/' itself intact; strip trailing slashes anywhere else.
    const trimmed = path.replace(/\/+$/, '') || '/';

    return super.parse(`${trimmed}${tail}`);
  }
}
